import { client } from '.';

export const viewXSLX = async (url, loading) => {
  // Change this to use your HTTP client
  client
    .get(url, { responseType: 'blob' })
    .then(response => {
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;',
      });
      // RETRIEVE THE BLOB AND CREATE LOCAL URL
      const _url = window.URL.createObjectURL(blob);
      window.open(_url, '_blank').focus(); // window.open + focus
    })
    .catch(err => {
      console.log(err);
    })
    .finally(() => loading(false));
};
